<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full" no-footer-line>
                <h4 slot="header" class="card-title">Manage Students</h4>
                <div>
                    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            
                            <el-select
                                class="select-primary mb-3"
                                style="width: 200px"
                                v-model="pagination.perPage"
                                v-if="pagination"
                                placeholder="Per page"
                            >
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                                ></el-option>
                            </el-select>

                            <el-tooltip class="item" effect="dark" content="Add Student" placement="top">
                            <n-button
                                @click.native="openModal()"
                                class="view ml-2"
                                type="primary"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-plus"></i>
                            </n-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="Upload Students" placement="top">
                            <n-button
                                @click.native="openUploadModal()"
                                class="view ml-2"
                                type="warning"
                                size="sm"
                                round
                                icon
                                simple
                            >
                                <i class="fa fa-upload"></i>
                            </n-button>
                            </el-tooltip>
                            <vue-json-to-csv :json-data="formattedData"
                                :labels="csvTitles"
                                :csv-title="`students-report`"
                                >
                                <el-tooltip class="item" effect="dark" content="Download CSV Report" placement="right">
                                <n-button class="download" type="success" size="sm" round icon simple style="margin-left: 10px">
                                    <i class="fa fa-download"></i>
                                </n-button>
                                </el-tooltip>
                            </vue-json-to-csv>
                            <vue-json-to-csv 
                                v-if="tableDataAll && tableDataAll.length > 0"
                                :json-data="formattedAllData"
                                :labels="csvTitles"
                                :csv-title="`all-students-report`"
                                >
                                <el-tooltip class="item" effect="dark" content="Download All Students CSV Report" placement="right">
                                <n-button class="download" type="success" size="sm" round icon simple style="margin-left: 10px">
                                    <i class="fa fa-download"></i>
                                </n-button>
                                </el-tooltip>
                            </vue-json-to-csv>
                            <template v-else>
                            <el-tooltip class="item" effect="dark" content="Loading all students data for download." placement="right">
                                <n-button type="success" size="sm" round icon simple style="margin-left: 10px;">
                                    <i class="fa fa-spinner fa-spin" style="top: 2px !important; left:2px !important;"></i>
                                </n-button>
                            </el-tooltip>
                            </template>
                        </div>
                        
                        <fg-input>
                            <el-input type="search"  class="mb-3" style="width: 400px"
                            prefix-icon="el-icon-search"
                            :placeholder="`Search by ${propsToSearch.join(', ').trim(', ').replace('.',' ')}`"
                            v-model="searchQuery"
                            aria-controls="datatables"
                            ></el-input>
                        </fg-input>
                    </div>
                    <el-table stripe style="width: 100%;" :data="tableData" size="mini">
                        <el-table-column
                            v-for="(column, index) in tableColumns"
                            :key="index"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label"
                            :sortable="column.sortable || false"
                            :align="column.align"
                            :header-align="column.align"
                            v-if="!column.hidden"
                            :fixed="column.fixed || false"
                            :formatter="column.formatter || null"
                        ></el-table-column>
                        
                        <el-table-column :min-width="180" fixed="right" label="Actions" align="right">
                            <div slot-scope="props" class="table-actions">
                                <el-tooltip class="item" effect="dark" content="View" placement="top">
                                    <n-button
                                        @click.native="handleView(props.$index, props.row)"
                                        class="view"
                                        type="primary"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-eye"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                                    <n-button
                                        @click.native="handleEdit(props.$index, props.row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                                    <n-button
                                        @click.native="handleDelete(props.$index, props.row)"
                                        class="remove"
                                        type="danger"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-times"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Reset Password" placement="top">
                                    <n-button
                                        @click.native="handleReset(props.$index, props.row)"
                                        class="reset"
                                        type="success"
                                        size="sm"
                                        round
                                        icon
                                        simple
                                    >
                                        <i class="fa fa-refresh"></i>
                                    </n-button>
                                </el-tooltip>
                            </div>
                        </el-table-column>
                    </el-table>
                </div>
                <div
                    slot="footer"
                    class="d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                    <div class>
                    <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <n-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                    ></n-pagination>
                </div>
            </card>
        </div>

        <modal :show.sync="modals.add" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Add New Student</h4>
            <form>
                <div class="row">
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="role"
                            label="Student Roles"
                            v-validate="modelValidations.role"
                            :error="getError('role')"
                            
                            v-model="model.role">
                            <el-select class="select-primary" placeholder="Select Roles" v-model="model.role" multiple collapse-tags filterable clearable>
                                <el-option v-for="(option, index) in roles" class="select-primary" :value="option.slug" :label="option.title" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="course"
                            label="Student Course"
                            v-validate="modelValidations.course"
                            :error="getError('course')"
                            v-model="model.course">
                            <el-select class="select-primary" placeholder="Select Course" v-model="model.course" filterable clearable>
                                <el-option v-for="(option, index) in batches" class="select-primary" :value="option" :label="option" :key="index"></el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="department"
                            label="Student Department"
                            v-validate="modelValidations.department"
                            :error="getError('department')"
                            v-model="model.department">
                            <el-select class="select-primary" placeholder="Select Department" v-model="model.department" filterable clearable>
                                <el-option v-for="(option, index) in departments" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            required
                            name="deanery"
                            label="Student Deanery"
                            v-validate="modelValidations.deanery"
                            :error="getError('deanery')"
                            v-model="model.deanery">
                            <el-select class="select-primary" placeholder="Select Deanery" v-model="model.deanery" filterable clearable>
                                <el-option v-for="(option, index) in deaneries" class="select-primary" :value="option" :label="option" :key="index">
                                </el-option>
                            </el-select>
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="register_no"
                            label="Student Register Number"
                            v-validate="modelValidations.register_no"
                            :error="getError('register_no')"
                            @change="updatePassword"
                            v-model="model.register_no">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="email"
                            name="mail"
                            label="Student Email"
                            v-validate="modelValidations.mail"
                            :error="getError('mail')"
                            v-model="model.mail">
                        </fg-input>
                    </div>
                    
                    <div class="col-6" v-if="model.password">
                        <fg-input
                            type="text"
                            name="password"
                            label="Student Password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            v-model="model.password">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="text"
                            name="name"
                            label="Student Name"
                            v-validate="modelValidations.name"
                            :error="getError('name')"
                            v-model="model.name">
                        </fg-input>
                    </div>
                    <div class="col-6">
                        <fg-input
                            type="date"
                            name="dob"
                            label="Date of Birth"
                            v-validate="modelValidations.dob"
                            :error="getError('dob')"
                            v-model="model.dob">
                            <el-date-picker 
                                v-model="model.dob" 
                                type="date" 
                                placeholder="Date of Birth">
                            </el-date-picker>
                        </fg-input>
                    </div>
                    <div class="col-4">
                        <fg-input
                            type="text"
                            name="session_start"
                            label="Session Start"
                            v-validate="modelValidations.session_start"
                            :error="getError('session_start')"
                            v-model="model.session_start">
                        </fg-input>
                    </div>
                    <div class="col-4">
                        <fg-input
                            type="text"
                            name="session_end"
                            label="Session End"
                            v-validate="modelValidations.session_end"
                            :error="getError('session_end')"
                            v-model="model.session_end">
                        </fg-input>
                    </div>
                    
                    <div class="col-4">
                        <fg-input
                            type="text"
                            name="section"
                            label="Section"
                            v-validate="modelValidations.section"
                            :error="getError('section')"
                            v-model="model.section">
                        </fg-input>
                    </div>
                    
                    
                    
                    
                </div>
            </form>
            <template slot="footer">
                <n-button @click.native.prevent="validate()" type="primary">Save Student</n-button>
            </template>
        </modal>

        <modal :show.sync="modals.upload" headerClasses="justify-content-center" footerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Upload New Students</h4>
            <form>
                <div class="row">

                    <div class="col-12">
                        <el-upload
                            drag
                            name="students"
                            class="upload-file"
                            ref="upload"
                            accept=".csv"
                            :limit="1"
                            :action="uploadURL"
                            :multiple="false"
                            :auto-upload="true"
                            :show-file-list="false"
                            :http-request="handleFileUpload"
                            :before-upload="handleFileBefore"
                            :on-exceed="handleFileExceed"
                            :on-success="handleFileSuccess"
                            :on-error="handleFileError"
                            :on-progress="handleFileProgress">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                                <div class="el-upload__tip" slot="tip">csv file with a size less than 5Mb | <a target="_blank" download href="/templates/students-upload-template.csv">Download Template CSV</a></div>
                        </el-upload>
                        
                        <el-progress 
                            v-if="fileUploadProgress.total > 0" 
                            :text-inside="true" :stroke-width="15"
                            :percentage="Math.round(fileUploadProgress.percent)" 
                            :status="(fileUploadProgress.percent == 100) ? 'success' : ''">
                        </el-progress>
                    </div>
                    
                </div>
            </form>
            <template slot="footer">
                <p class="status" :class="uploadStatusClass">{{ uploadStatus }}</p>
            </template>
        </modal>

    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Upload, Progress, DatePicker  } from "element-ui";
import { Pagination as NPagination, Modal  } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import VueJsonToCsv from 'vue-json-to-csv'
import JsonCSV from 'vue-json-csv'

import { mapGetters } from 'vuex';

export default {
    components: {
        NPagination,
        VueJsonToCsv,
        JsonCSV,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Upload.name]: Upload,
        [Progress.name]: Progress,
        [DatePicker.name]: DatePicker,
        Modal
    },
    computed: {
        ...mapGetters({
            tableData: 'getStudents',
            departments: 'getDepartments',
            deaneries: 'getDeaneries',
            courses: 'getCourses',
            roles: 'getRoles',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
            batches: 'getBatches',
            tableDataAll: 'getAllStudents'
        }),

        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.searchedData;
            // if (this.searchedData.length > 0) {
            //     result = this.searchedData;
            // }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.tableData.length;
        },
        uploadURL(){
            return `${process.env.VUE_APP_ADMIN_URL}/users/students/csv`
        },
        formattedData(){
            return this.tableData.map(item => {
                let el = JSON.parse(JSON.stringify(item))
                el.role = el.role.join(', ').trim(', ');
                el.start = el.session.start;
                el.end = el.session.end;
                return el
            })
        },
        formattedAllData(){
            return this.tableDataAll.map(item => {
                let el = JSON.parse(JSON.stringify(item))
                el.role = el.role.join(', ').trim(', ');
                el.start = el.session.start;
                el.end = el.session.end;
                return el
            })
        }
    },
    data() {
        return {
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: [ "register_no" ],
            tableColumns: [
                {
                    prop: "_id",
                    label: "ID",
                    hidden: true,
                    minWidth: 200,
                },
                {
                    prop: "register_no",
                    label: "Reg #",
                    minWidth: 200,
                    align: 'center',
                    sortable: false,
                    fixed: true,
                },
                {
                    prop: "name",
                    label: "Name",
                    minWidth: 250,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "mail",
                    label: "Email",
                    minWidth: 300,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "course",
                    label: "Course",
                    minWidth: 250,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "section",
                    label: "Section",
                    minWidth: 150,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "session.start",
                    label: "S.Start",
                    minWidth: 150,
                    align: 'center',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "session.end",
                    label: "S.End",
                    minWidth: 150,
                    align: 'center',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "department",
                    label: "Department",
                    minWidth: 200,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "deanery",
                    label: "Deanery",
                    minWidth: 250,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                },
                {
                    prop: "dob",
                    label: "DOB",
                    minWidth: 200,
                    align: 'left',
                    sortable: false,
                    fixed: false,
                    formatter: function(row, column, cellValue, index){
                        var d = new Date(cellValue);
                        var options = { year: 'numeric', month: 'long', day: 'numeric' }
                        return  d.toLocaleDateString('en-US', options); 
                    }
                }
                
            ],
            searchedData: [],
            fuseSearch: null,
            modals: {
                add: false,
                upload: false
            },
            model: {
                _id: null,
                role: [],
                mail: '',
                password: 'secret',
                user_type: 'student',
                register_no: '',
                name: '',
                session_start: '',
                session_end: '',
                course: null,
                section: '',
                department: null,
                deanery: null,
                dob: null
            },
            modelValidations: {
                role: {
                    required: true,
                },
                mail: {
                    email: true,
                    required: true,
                },
                password: {
                    required: true,
                    min: 6
                },
                name: {
                    required: true,
                },
                register_no: {
                    required: true,
                },
                session_start: {
                    required: true,
                },
                session_end: {
                    required: true,
                },
                course: {
                    required: true,
                },
                section: {
                    required: true,
                },
                department: {
                    required: true,
                },
                deanery: {
                    required: true,
                },
                dob: {
                    required: true,
                },
            },
            filterMethod(query, item) {
                return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
            },
            uploadStatusClass: 'text-info',
            uploadStatus: '',
            fileUploadProgress: {
                percent: 0,
                loaded: 0,
                total: 0
            },
            csvTitles: { 
                register_no : { title: "Register No" },
                name : { title: "Name" },
                mail : { title: "Email" },
                course : { title: "Course" }, 
                section : { title: "Section" }, 
                start : { title: "Session Start" }, 
                end : { title: "Session End" }, 
                department : { title: "Department" }, 
                deanery : { title: "Deanery" },
                dob: {title: 'DOB'},
                blood_group: {title: 'Blood Group'},
                role: {title: 'Role'}
            },
        };
    },
    methods: {
        handleFileBefore(file) {
            const isCSV = file.type === 'text/csv';
            const isLt5M = file.size / 1024 / 1024 < 5;

            this.uploadStatusClass = 'text-info'
            this.uploadStatus = ''
            this.fileUploadProgress =  {
                percent: 0,
                loaded: 0,
                total: 0
            }

            if (!isCSV) {
                this.uploadStatusClass = 'text-danger'
                this.uploadStatus = 'File must be CSV format!'
            }
            if (!isLt5M) {
                this.uploadStatusClass = 'text-danger'
                this.uploadStatus = 'File size can not exceed 5MB!'
            }
            return isCSV && isLt5M;
        },
        // not used
        handleFileUpload() {
            const file = this.$refs.upload.uploadFiles[0]
            let formData = new FormData()
            formData.append('students', file.raw)
            this.$store.dispatch('uploadCSV', {type: 'students', payload: formData})
        },
        handleFileSuccess(response, file, fileList) {
            // handleFileSuccess
            if(response.status == 200){
                this.uploadStatusClass = 'text-success'
                this.uploadStatus = 'File uploaded'
                this.$refs.upload.clearFiles()
            }
        },
        handleFileError(err, file, fileList) {
            // handleFileError
            this.uploadStatusClass = 'text-danger'
            this.uploadStatus = 'error'
            this.$refs.upload.clearFiles()
        },
        handleFileProgress(event, file, fileList) {
            // handleFileProgress
            this.fileUploadProgress = event
            this.uploadStatusClass = 'text-infp'
            this.uploadStatus = 'progressing'
        },
        handleFileExceed(files, fileList) {
            // handleFileExceed
            this.uploadStatusClass = 'text-warning'
            this.uploadStatus = 'Files upload limit exceeded!'
            this.$refs.upload.clearFiles()
        },

        handleView(index, row) {
            // handleView
        },
        handleEdit(index, row) {

            this.model = Object.assign({}, row);
            this.model.session_start = row.session.start
            this.model.session_end = row.session.end

            this.scope = 'edit'
            this.modals.add = true
        },
        handleDelete(index, row) {
            swal({
                title: "Are you sure?",
                text: `You won't be able to revert this!`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Delete it!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.deleteRow(row);
                }
            });
        },
        handleReset(index, row) {
            swal({
                title: "Are you sure?",
                text: `Password will be reset to the register number.`,
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger btn-fill",
                cancelButtonClass: "btn btn-default btn-fill",
                confirmButtonText: "Reset Password!",
                buttonsStyling: false
            }).
            then(result => {
                if (result.value) {
                    this.$store.dispatch('resetPassword', {mail: row.mail})
                }
            });
        },
        
        deleteRow(row) {
            this.$store.dispatch('deleteStudent', {payload: row.user_id, per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery})
        },
        openModal(){

            this.errors.clear();
            this.$nextTick(() => {
                this.$validator.reset();
            });
            
            this.model.role = []
            this.model.mail = ''
            this.model.password = 'secret'
            this.model.user_type = 'student'
            this.model.register_no = ''
            this.model.name = ''
            this.model.session_start = ''
            this.model.session_end = ''
            this.model.course = null
            this.model.section = null
            this.model.department = null
            this.model.deanery = null

            this.scope = 'add'
            this.modals.add = true
        },
        openUploadModal(){
            this.scope = 'upload'
            this.modals.upload = true
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            this.$validator.validateAll().then(isValid => {
                // this.$emit('on-submit', this.registerForm, isValid);
                if(isValid){
                    
                    switch(this.scope){
                        case 'add'  : this.$store.dispatch('createStudent', {payload: this.model, per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery}); break;
                        case 'edit' : this.$store.dispatch('updateStudent', {payload: this.model, per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery}); break;
                    }
                    
                    this.modals.add = false
                }
            });
        },
        updatePassword(){
            this.model.password = this.model.register_no
        }
    },
    mounted() {
        // Fuse search initialization.
        // this.fuseSearch = new Fuse(this.tableData, {
        //     keys: this.propsToSearch,
        //     threshold: 0.1
        // });

        this.$nextTick(() => {
            this.pagination.perPage = this.preferences.perPage
        })

        this.$store.dispatch('getDepartments');
        this.$store.dispatch('getDeaneries');
        this.$store.dispatch('getCourses');
        this.$store.dispatch('getRoles');
        this.$store.dispatch('getBatches');
        this.$store.dispatch('getAllStudents');
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery: {
            handler: function(value){
                // let result = Object.assign([], this.tableData);
                // if (value !== "") {
                //     result = this.fuseSearch.search(value);
                // }
                // this.searchedData = result;

                value = value.trim()

                if(value.length >= 5)
                    this.$store.dispatch('getStudents', {per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery});
                else if(value.length == 0)
                    this.$store.dispatch('getStudents', {per_page: this.pagination.perPage, page: this.pagination.currentPage, search: null});


            },
            immediate: true
        },

        tableData: {
            handler: function(value){
                // this.fuseSearch = new Fuse(value, {
                //     keys: this.propsToSearch,
                //     threshold: 0.1
                // })
                // let result = Object.assign([], value);
                // if (this.searchQuery !== "") {
                //     result = this.fuseSearch.search(this.searchQuery);
                // }
                // this.searchedData = result;
            },
            immediate: true
        },

        'pagination.perPage'(value){
            this.preferences.perPage = value
            this.$store.commit('setPreferences', this.preferences)
            this.$store.dispatch('getStudents', {per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery});
        },

        'pagination.currentPage'(value){
            this.$store.dispatch('getStudents', {per_page: this.pagination.perPage, page: this.pagination.currentPage, search: this.searchQuery});
        },

        'preferences.perPage': {
            handler: function(value){
                this.pagination.perPage = value
            },
            immediate: true
        }
    }
};
</script>
<style lang="scss">
    .has-success.has-label:after, 
    .has-danger.has-label:after {
        top: 43px;
    }

    .el-transfer-panel__filter.el-input{
        width: 85%;
    }

    .upload-file{
        text-align: center;
    }

    p.status{
        text-align: center;
        width: 100%;
        display: block;
    }

    .el-upload__tip a {
        color: #409EFF;
        font-style: normal;
        cursor: pointer;
    }
    .el-progress{
        width: 75%;
        margin: 10px auto;
    }

    .el-progress-bar{
        margin-right: -25px;
        padding-right: 25px;
    }
</style>

